var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c1caf09de0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 19.398438 L 375 19.398438 L 375 337.398438 L 0 337.398438 Z M 0 19.398438 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 349.660156 120.351562 C 346.597656 100.679688 329.738281 86.632812 310.066406 86.632812 L 83.480469 86.632812 C 63.808594 86.632812 46.949219 100.9375 43.882812 120.351562 C 41.074219 138.488281 38.265625 163.777344 38.265625 194.6875 C 38.519531 225.597656 41.074219 250.886719 43.882812 269.023438 C 46.949219 288.4375 63.808594 302.746094 83.480469 302.746094 L 309.8125 302.746094 C 329.480469 302.746094 346.597656 288.4375 349.40625 269.023438 C 352.214844 250.632812 355.027344 225.597656 355.027344 194.6875 C 355.027344 163.777344 352.472656 138.488281 349.660156 120.351562 Z M 163.179688 237.859375 L 163.179688 151.773438 L 243.394531 194.945312 Z M 163.179688 237.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c1caf09de0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 196.644531 497.910156 C 29.578125 497.910156 -106.578125 362.007812 -106.578125 194.6875 C -106.578125 27.621094 29.578125 -108.535156 196.644531 -108.535156 C 363.710938 -108.535156 499.867188 27.621094 499.867188 194.6875 C 499.867188 362.007812 363.96875 497.910156 196.644531 497.910156 Z M 196.644531 -91.929688 C 38.519531 -91.929688 -89.972656 36.5625 -89.972656 194.6875 C -89.972656 352.8125 38.519531 481.304688 196.644531 481.304688 C 354.769531 481.304688 483.261719 352.8125 483.261719 194.6875 C 483.261719 36.5625 354.769531 -91.929688 196.644531 -91.929688 Z M 196.644531 -91.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon1);
export default __webpack_public_path__ + "static/media/nav-icon1.6d19b4c4c7e44ed6e4338d409c8037a3.svg";
export { ForwardRef as ReactComponent };